import { CircularProgress } from "@minuthq/meatball-ui-react"

import { useAssigneeOptions } from "src/data/taskManagement/hooks/useAssigneeOptions"
import { DropdownSelect } from "src/ui/DropdownSelect/DropdownSelect"

export function AssigneeDropdownSelect({
  loading,
  initialValue,
  onChange,
}: {
  loading: boolean
  initialValue: string
  onChange: (option: string) => void
}) {
  const { options, initialAssignee, handleSearch } =
    useAssigneeOptions(initialValue)

  if (loading) {
    return <CircularProgress />
  }

  return (
    <DropdownSelect
      label={initialAssignee.label}
      options={options}
      selectedValue={initialAssignee.value}
      onSearch={handleSearch}
      onChange={({ option }) => onChange(option.value)}
      mButtonVariant="minimal"
    />
  )
}
